
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SubMenuCards from './SubMenuCards';

import platformSAPAEH from '../Data/PlatformSAPAEH.json'
import DataAEH from '../Data/DataAEH.json'
import SalesforceAEH from '../Data/SalesForceAEH.json'
import InfrasturctureEngineeringAEH from '../Data/InfrastructureEngAEH.json'
import CustomEng from '../Data/CustomEngineeringAEH.json'
import WorkDay from '../Data/WorkDayAEH.json'
import OracleAEH from '../Data/OracelAEH.json'



const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

function CustomizedAccordionsAEH() {
  const [expanded, setExpanded] = React.useState('panel1');
  let [accordsName, setAccordsName] = React.useState('');
  const handleChange = (panel, accordName) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    setAccordsName(accordName);
  };


  var streamsData = platformSAPAEH
                    .concat(DataAEH)
                    .concat(SalesforceAEH)
                    .concat(InfrasturctureEngineeringAEH)
                    .concat(CustomEng)
                    .concat(WorkDay)
                    .concat(OracleAEH)
                    ;

  return streamsData.filter(p => p.Display === true).map((data) => {
    return (
      <div id="stream-sec">
        <Accordion square expanded={expanded === `panel1${data.id}`} onChange={handleChange(`panel1${data.id}`, data.Name)} >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1d-content" id="panel1d-header">
            <h3>{data.Name}</h3>
          </AccordionSummary>
          <AccordionDetails>
            <SubMenuCards streams={data.streams.filter(p => p.Display === true)} AccordName={data.Default} />
          </AccordionDetails>
        </Accordion>
      </div>
    );
  });
}
export default CustomizedAccordionsAEH;